// extracted by mini-css-extract-plugin
export default {"featuredIcon":"featured-icon_featuredIcon__W9Nbr"};